import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_SALESDETAIL,
  DELETE_SALESDETAIL,
  UPDATE_SALESDETAIL,
  ADD_NEW_SALESDETAIL,
} from "./actionType";

import {
  getSalesDetailSuccess,
  getSalesDetailFail,
  deleteSalesDetailSuccess,
  deleteSalesDetailFail,
  updateSalesDetailSuccess,
  updateSalesDetailFail,
  addSalesDetailSuccess,
  addSalesDetailFail,
} from "./action";

//Include Both Helper File with needed carriers
import {
  approveSalesDetailApi,
  getSalesDetailApi,
  updateSalesDetailApi,
  deleteSalesDetailApi,
  addNewSalesDetailApi
} from "../../helpers/backend_helper";

function* getSalesDetail({ payload: salesDetail }) {
  try {
    const response = yield call(getSalesDetailApi, salesDetail);
    yield put(getSalesDetailSuccess(GET_SALESDETAIL, response.data));
  } catch (error) {
    yield put(getSalesDetailFail(GET_SALESDETAIL, error));
  }
}

function* onUpdateSalesDetail({ payload: salesDetail }) {
  try {
    if (salesDetail.setApprove) {
      const response = yield call(approveSalesDetailApi, salesDetail);
      yield put(updateSalesDetailSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateSalesDetailApi, salesDetail);
      yield put(updateSalesDetailSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateSalesDetailFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteSalesDetail({ payload: salesDetail }) {
  try {
    const response = yield call(deleteSalesDetailApi, salesDetail);
    yield put(deleteSalesDetailSuccess({ salesDetail, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteSalesDetailFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewSalesDetail({ payload: salesDetail }) {
  try {
    const response = yield call(addNewSalesDetailApi, salesDetail);
    yield put(addSalesDetailSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addSalesDetailFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetSalesDetail() {
  yield takeEvery(GET_SALESDETAIL, getSalesDetail);
}

export function* watchUpdateSalesDetail() {
  yield takeEvery(UPDATE_SALESDETAIL, onUpdateSalesDetail);
}

export function* watchDeleteSalesDetail() {
  yield takeEvery(DELETE_SALESDETAIL, onDeleteSalesDetail);
}

export function* watchAddNewSalesDetail() {
  yield takeEvery(ADD_NEW_SALESDETAIL, onAddNewSalesDetail);
}

function* salesDetailSaga() {
  yield all([
    fork(watchGetSalesDetail),
    fork(watchDeleteSalesDetail),
    fork(watchUpdateSalesDetail),
    fork(watchAddNewSalesDetail)
  ]);
}

export default salesDetailSaga;
